import React from "react";
import "./Page404.scss";
import {Layout} from "../../../components/Layout";

const Page404 = () => {
    return (
        <Layout>
            <div
                className="not-found-wrapper"
            >
                <section className="not-found-container">
                    <div className="not-found-image">
                        <img src="Content/Images/404-page-not-found.png"></img>
                        <div className="not-found-text">
                            <span>Page can't be found!</span>
                        </div>
                    </div>
                </section>
            </div>
        </Layout>
    );
};

export default Page404;
